/* src/app/container/pubblicazioni-list/pubblicazioni-list.component.scss */
:host {
  height: 100% !important;
}
::ng-deep .p-table-albi-pubblicazioni-list {
}
::ng-deep .p-table-albi-pubblicazioni-list .esiti-caption-row .p-selectbutton {
  flex-wrap: nowrap;
}
::ng-deep .p-table-albi-pubblicazioni-list .esiti-caption-row .p-selectbutton .p-button {
  border: 0.06rem solid #9da3a9 !important;
  background-color: #f4f4f4 !important;
}
::ng-deep .p-table-albi-pubblicazioni-list .esiti-caption-row .p-selectbutton .p-button:hover {
  color: #333333;
  background-color: rgba(4, 141, 79, 0.6117647059) !important;
  border-color: rgba(4, 141, 79, 0.6117647059) !important;
}
::ng-deep .p-table-albi-pubblicazioni-list .esiti-caption-row .p-selectbutton .p-highlight {
  color: white;
  background-color: #40845a !important;
}
@media screen and (max-width: 80rem) {
  ::ng-deep .p-table-albi-pubblicazioni-list .esiti-caption-row {
    font-size: 10pt;
  }
  ::ng-deep .p-table-albi-pubblicazioni-list .esiti-caption-row .p-buttonselect {
    font-size: 10pt;
  }
  ::ng-deep .p-table-albi-pubblicazioni-list .esiti-caption-row .p-buttonselect .p-selectbutton {
    display: flex;
    font-size: small;
    flex-wrap: nowrap;
    align-self: center;
    font-size: 10pt;
  }
}
::ng-deep .p-table-albi-pubblicazioni-list .pubblicazionilist-table-body {
  overflow: initial !important;
}
::ng-deep .p-table-albi-pubblicazioni-list .pubblicazionilist-table-body .header-row {
  height: 2.563rem;
}
::ng-deep .p-table-albi-pubblicazioni-list .pubblicazionilist-table-body .header-row .header-column {
  padding: 0.13rem 0.813rem;
}
::ng-deep .p-table-albi-pubblicazioni-list .pubblicazionilist-table-body .header-row .header-column .header-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: black;
}
::ng-deep .p-table-albi-pubblicazioni-list .pubblicazionilist-table-body .header-row .header-column .header-box:hover {
  color: rgba(4, 141, 79, 0.6117647059);
}
@media screen and (max-width: 80rem) {
  ::ng-deep .p-table-albi-pubblicazioni-list .pubblicazionilist-table-body .filter-row {
    font-size: 11pt;
  }
}
::ng-deep .p-table-albi-pubblicazioni-list .pubblicazionilist-table-body .filter-row .filter-column {
  padding: 0.06rem;
  border: transparent;
}
::ng-deep .p-table-albi-pubblicazioni-list .pubblicazionilist-table-body .filter-row .filter-column div:first-child {
  width: 100%;
}
::ng-deep .p-table-albi-pubblicazioni-list .pubblicazionilist-table-body .filter-row .filter-column .p-inputnumber-buttons-stacked .p-inputnumber-input {
  border-radius: 0.19rem;
}
::ng-deep .p-table-albi-pubblicazioni-list .pubblicazionilist-table-body .filter-row .filter-column .p-inputnumber-button-group {
  display: none;
}
::ng-deep .p-table-albi-pubblicazioni-list .pubblicazionilist-table-body .filter-row .filter-column .p-select-label,
::ng-deep .p-table-albi-pubblicazioni-list .pubblicazionilist-table-body .filter-row .filter-column .p-multiselect-label,
::ng-deep .p-table-albi-pubblicazioni-list .pubblicazionilist-table-body .filter-row .filter-column p-calendar .p-inputtext {
  font-size: 0.75rem;
  text-align: center;
}
::ng-deep .p-table-albi-pubblicazioni-list .pubblicazionilist-table-body .filter-row .filter-column .p-inputtext {
  font-size: 0.75rem;
}
::ng-deep .p-table-albi-pubblicazioni-list .pubblicazionilist-table-body .filter-row .filter-column .p-calendar input {
  font-size: 0.75rem;
  text-align: center;
}
::ng-deep .p-table-albi-pubblicazioni-list .pubblicazionilist-table-body .filter-row .filter-column.controinteressati-column p-columnfilterformelement {
  justify-content: center;
  padding: 0.3rem;
}
::ng-deep .p-table-albi-pubblicazioni-list .pubblicazionilist-table-body .search-wrapper {
  display: flex;
  width: 100%;
  height: 100%;
  background-color: white;
  border: 0.06rem solid #a6a6a6;
  border-radius: 0.19rem;
}
::ng-deep .p-table-albi-pubblicazioni-list .pubblicazionilist-table-body .search-wrapper .autocomplete-esecutivita {
  width: 100%;
}
::ng-deep .p-table-albi-pubblicazioni-list .pubblicazionilist-table-body .search-wrapper p-columnfilter {
  display: flex;
  width: 100%;
}
::ng-deep .p-table-albi-pubblicazioni-list .pubblicazionilist-table-body .search-wrapper p-columnfilter .p-multiselect,
::ng-deep .p-table-albi-pubblicazioni-list .pubblicazionilist-table-body .search-wrapper p-columnfilter .p-inputtext {
  border: none !important;
}
::ng-deep .p-table-albi-pubblicazioni-list .pubblicazionilist-table-body .search-wrapper p-columnfilter .p-calendar input {
  font-size: 0.75rem;
  text-align: center;
}
::ng-deep .p-table-albi-pubblicazioni-list .pubblicazionilist-table-body .search-wrapper .close-icon {
  align-self: center;
  font-size: 0.938rem;
  border: 0.06rem solid transparent;
  background-color: white;
  display: inline-block;
  vertical-align: middle;
  outline: 0;
  cursor: pointer;
}
::ng-deep .p-table-albi-pubblicazioni-list .pubblicazionilist-table-body .p-datatable-tbody > tr > td {
  height: 100%;
  padding: 0;
}
::ng-deep .p-table-albi-pubblicazioni-list .pubblicazionilist-table-body .p-datatable-tbody > tr > td:not(.p-checkbox, .p-checkbox-box) div {
  height: 5.313rem;
  padding: 0.563rem 0.813rem;
}
::ng-deep .p-table-albi-pubblicazioni-list .pubblicazionilist-table-body .p-datatable-tbody > tr > td:not(.scrollable-column) div {
  display: flex;
  align-items: center;
  margin: auto;
}
::ng-deep .p-table-albi-pubblicazioni-list .pubblicazionilist-table-body .p-datatable-tbody > tr > td.scrollable-column div {
  overflow: hidden;
  word-wrap: break-word;
  word-break: break-word;
}
::ng-deep .p-table-albi-pubblicazioni-list .pubblicazionilist-table-body .p-datatable-tbody > tr > td.scrollable-column div:hover {
  overflow-y: scroll;
  overflow-y: overlay;
}
::ng-deep .p-table-albi-pubblicazioni-list .pubblicazionilist-table-body .p-datatable-tbody > tr > td.data-creazione-column div,
::ng-deep .p-table-albi-pubblicazioni-list .pubblicazionilist-table-body .p-datatable-tbody > tr > td.data-registrazione-column div {
  justify-content: center;
}
::ng-deep .p-table-albi-pubblicazioni-list .cdk-virtual-scroll-viewport {
  overflow: scroll !important;
  overflow: overlay !important;
}
::ng-deep .p-table-albi-pubblicazioni-list .row-height {
  height: 85px;
  max-height: 5.625rem;
  font-size: 0.813rem;
}
::ng-deep .p-table-albi-pubblicazioni-list .motivazione-column,
::ng-deep .p-table-albi-pubblicazioni-list .articolazione-column {
  max-width: 13.75rem;
  min-width: 13.75rem;
  cursor: pointer;
}
::ng-deep .p-table-albi-pubblicazioni-list .motivazione-column .motivazione-content,
::ng-deep .p-table-albi-pubblicazioni-list .motivazione-column .articolazione-content,
::ng-deep .p-table-albi-pubblicazioni-list .articolazione-column .motivazione-content,
::ng-deep .p-table-albi-pubblicazioni-list .articolazione-column .articolazione-content {
  align-items: normal !important;
  overflow-y: auto;
  width: 100%;
  height: 100%;
}
::ng-deep .p-table-albi-pubblicazioni-list .tipo-provvedimento-column {
  min-width: 13.125rem;
  max-width: 13.125rem;
}
::ng-deep .p-table-albi-pubblicazioni-list .esecutivita-column,
::ng-deep .p-table-albi-pubblicazioni-list .dati-registro-column {
  min-width: 15.625rem;
  max-width: 15.625rem;
}
::ng-deep .p-table-albi-pubblicazioni-list .articolazione2-column,
::ng-deep .p-table-albi-pubblicazioni-list .tipoProcedimento-column,
::ng-deep .p-table-albi-pubblicazioni-list .dati-pubblicazione-column {
  min-width: 9.375rem;
  max-width: 9.375rem;
}
::ng-deep .p-table-albi-pubblicazioni-list .articolazione2-column .articolazione2-content,
::ng-deep .p-table-albi-pubblicazioni-list .tipoProcedimento-column .articolazione2-content,
::ng-deep .p-table-albi-pubblicazioni-list .dati-pubblicazione-column .articolazione2-content {
  align-items: normal !important;
  overflow-y: auto;
  width: 100%;
  height: 100%;
}
::ng-deep .p-table-albi-pubblicazioni-list .dataIniziativa-column,
::ng-deep .p-table-albi-pubblicazioni-list .dataChiusura-column,
::ng-deep .p-table-albi-pubblicazioni-list .esito-column,
::ng-deep .p-table-albi-pubblicazioni-list .controinteressati-column,
::ng-deep .p-table-albi-pubblicazioni-list .attoDiIniziativa-column,
::ng-deep .p-table-albi-pubblicazioni-list .provvedimentoFinale-column,
::ng-deep .p-table-albi-pubblicazioni-list .data-registrazione-column,
::ng-deep .p-table-albi-pubblicazioni-list .data-inserimento-column,
::ng-deep .p-table-albi-pubblicazioni-list .data-adozione-column,
::ng-deep .p-table-albi-pubblicazioni-list .data-esecutivita-column,
::ng-deep .p-table-albi-pubblicazioni-list .data-pubblicazione-column,
::ng-deep .p-table-albi-pubblicazioni-list .data-ultima-modifica-column,
::ng-deep .p-table-albi-pubblicazioni-list .data-fine-pubblicazione-column {
  min-width: 10rem;
  max-width: 10rem;
}
::ng-deep .p-table-albi-pubblicazioni-list .justify-center {
  justify-content: center;
}
::ng-deep .p-table-albi-pubblicazioni-list .scrollable {
  overflow-y: hidden;
  margin: 0.5rem !important;
}
::ng-deep .p-table-albi-pubblicazioni-list .registro-column,
::ng-deep .p-table-albi-pubblicazioni-list .numero-registro-column,
::ng-deep .p-table-albi-pubblicazioni-list .anno-registro-column {
  min-width: 6.875rem;
  max-width: 6.875rem;
}
::ng-deep .p-table-albi-pubblicazioni-list .oggetto-column {
  min-width: 21.875rem;
  font-weight: 37.5rem;
  flex: 1 1 0 !important;
}
::ng-deep .p-table-albi-pubblicazioni-list .oggetto-column .oggetto-content {
  align-items: normal !important;
  overflow-y: auto;
  width: 100%;
  height: 100%;
}
::ng-deep .p-table-albi-pubblicazioni-list .cig-content,
::ng-deep .p-table-albi-pubblicazioni-list .cigAzienda-content,
::ng-deep .p-table-albi-pubblicazioni-list .linkBdncp-content,
::ng-deep .p-table-albi-pubblicazioni-list .linkIntercent-content {
  align-items: normal !important;
  overflow-y: auto;
  width: 100%;
  height: 100%;
}
::ng-deep .table-zero-rows .p-datatable-scrollable-header {
  overflow: scroll !important;
}
.loading-cell {
  padding: 0.571rem 0.857rem !important;
}
.loading-cell .loading-text {
  display: block;
  background-color: #f1f1f1;
  min-height: 1.188rem;
  animation: pulse 1s infinite ease-in-out;
  text-indent: -6249.938rem;
  overflow: hidden;
}
.calendar-filter-footer-button-container {
  display: flex;
  justify-content: space-around;
}
::ng-deep body p-table .p-datatable .p-datatable-wrapper .cdk-virtual-scroll-viewport .cdk-virtual-scroll-content-wrapper table .p-datatable-thead > tr > th.p-highlight {
  background-color: #c6c6c6 !important;
  color: #ffffff;
}
/*# sourceMappingURL=pubblicazioni-list.component.css.map */
